import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { azureResourceSelectMethodOptions } from '../consts/metadata-consts';
import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import {
    eventHubResourceId, eventHubResourceIdErrorMessage, eventHubResourceIdFormat,
    getManualResourceIdControl, getReadonlyControl
} from './shared-control-metadata';

export const azureEventHubPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.EventHub/namespaces',
    resourceIdValidator: eventHubResourceIdFormat,
    connectionSuffix: 'networking',
    groupIdMetadata: {
        namespace: {
            groupId: 'namespace',
            linkedServiceType: adfModelTypeMap.eventHubs.linkedServiceType,
            displayName: stringResources.EventHubs_DisplayText,
            iconClass: 'svg-i-100x100-event_hubs',
            controls: {
                creationControls: getCreationControls(),
                readonlyControls: getReadonlyControls()
            }
        }
    }
};

function getCreationControls(): ControlMetadata[] {
    return [{
        type: 'radio-switch',
        nested: 1,
        label: stringResources.AccountSelectionMethodLabel,
        description: stringResources.EventHubs_SelectMethod_Description,
        options: azureResourceSelectMethodOptions,
        isLabelVertical: true,
        defaultValue: '{privateLinkResourceId != null ? "manual" : "azure"}',
        cases: [
            {
                caseValue: 'azure',
                children: [
                    {
                        type: 'event-hubs-select',
                        bind: {
                            peResourceId: 'privateLinkResourceId'
                        },
                        isPEConfig: true,
                        onlyKafkaSupportedNS: false
                    }
                ]
            },
            {
                caseValue: 'manual',
                children: [
                    getManualResourceIdControl(
                        format(stringResources.PrivateEndpointResourceIdPlaceholder, eventHubResourceId),
                        eventHubResourceIdFormat,
                        eventHubResourceIdErrorMessage)
                ]
            }
        ]
    }];
}
function getReadonlyControls(): ControlMetadata[] {
    return getReadonlyControl(eventHubResourceIdFormat, eventHubResourceIdErrorMessage);
}
